import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../utils/AppUtils";
import Modal from 'react-bootstrap/Modal';
import _ from "lodash"
import CONFIG from "../../utils/config";

const RolePlayHeadingSection = (props) => {

    const navigate = useNavigate();

    const authBroker = useSelector(state => state.auth.authBroker)
    const userDetailRes = useSelector((state) => state.user.userBroker);

    const [roleArray, setRoleArray] = useState([])

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            setRoleArray(authBroker.payload.user.role)
        }
    }, [authBroker])

    const redirectToRecord = () => {
        clickStreamUser('participate-roleplay-tab-clicked', {
            user_id: authBroker?.payload.user?.user_id
        })
        props.isMobile ?
            navigate(`/role-play-mobile`) :
            navigate('/role-play')
    }
    const [show, setShow] = useState(false);
    const [coachShow, setCoachShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleCoachClose = () => setCoachShow(false);
    const handleCoachShow = () => setCoachShow(true);

    const redirectToGuide = (type) => {
        if (type === 'participant') {
            window.open(CONFIG.ROLEPLAY_PARTICIPANT_GUIDE, '_blank');
        } else {
            window.open(CONFIG.ROLEPLAY_COACH_GUIDE, '_blank');
        }
    }

    return (
        <>
            <section className="newsarticle roleplay-page pt-6">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="events_banner roplbnpag">
                                <p className="label-heading_events mb-4 rphnain">Role play</p>
                                <div className="roleplaybtn d-flex gap-3">
                                        <button className="btn-primary reviewbtn guidebtn rpsubmitbtn d-flex gap-1 align-items-center" onClick={handleShow}>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="19.06" height="17.318" viewBox="0 0 19.06 17.318">
                                            <g id="UG_Icon" transform="translate(-23.1 -7.031)">
                                                <path id="Path_14017" data-name="Path 14017" d="M3.172-8.493a3.351,3.351,0,0,1-.2,1.2,2.681,2.681,0,0,1-.559.9,4.016,4.016,0,0,1-.867.683,7.649,7.649,0,0,1-1.141.549v1.528H-1.949V-5.893q.475-.127.86-.261A3.237,3.237,0,0,0-.282-6.59a2.136,2.136,0,0,0,.619-.623,1.475,1.475,0,0,0,.224-.8A1.058,1.058,0,0,0,.13-8.974a2.2,2.2,0,0,0-1.215-.285,3.4,3.4,0,0,0-1.088.208,4.945,4.945,0,0,0-1.108.536h-.268v-2.042a8.247,8.247,0,0,1,1.319-.378,8.321,8.321,0,0,1,1.807-.2A4.266,4.266,0,0,1,2.2-10.4,2.28,2.28,0,0,1,3.172-8.493ZM.6-.958h-2.7V-2.725H.6Z" transform="translate(38.988 18.164)" fill="#1a3a4c"/>
                                                <path id="account-plus" d="M11.941,12.222c-2.2,0-6.578,1.094-6.578,3.289v1.644H18.519V15.511c0-2.2-4.382-3.289-6.578-3.289m0-1.644A3.289,3.289,0,1,0,8.652,7.289,3.289,3.289,0,0,0,11.941,10.578Z" transform="translate(17.737 7.194)" fill="#1a3a4c"/>
                                            </g>
                                            </svg>
                                            {roleArray.includes('coach') ? 'User Guide' : 'User Guide'}
                                        </button> 
                                        {
                                            roleArray.includes('coach') ?
                                            <button className="btn-primary reviewbtn guidebtn rpsubmitbtn d-flex gap-1 align-items-center" onClick={handleCoachShow}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="19.06" height="17.318" viewBox="0 0 19.06 17.318">
                                                <g id="UG_Icon" transform="translate(-23.1 -7.031)">
                                                    <path id="Path_14017" data-name="Path 14017" d="M3.172-8.493a3.351,3.351,0,0,1-.2,1.2,2.681,2.681,0,0,1-.559.9,4.016,4.016,0,0,1-.867.683,7.649,7.649,0,0,1-1.141.549v1.528H-1.949V-5.893q.475-.127.86-.261A3.237,3.237,0,0,0-.282-6.59a2.136,2.136,0,0,0,.619-.623,1.475,1.475,0,0,0,.224-.8A1.058,1.058,0,0,0,.13-8.974a2.2,2.2,0,0,0-1.215-.285,3.4,3.4,0,0,0-1.088.208,4.945,4.945,0,0,0-1.108.536h-.268v-2.042a8.247,8.247,0,0,1,1.319-.378,8.321,8.321,0,0,1,1.807-.2A4.266,4.266,0,0,1,2.2-10.4,2.28,2.28,0,0,1,3.172-8.493ZM.6-.958h-2.7V-2.725H.6Z" transform="translate(38.988 18.164)" fill="#1a3a4c"/>
                                                    <path id="account-plus" d="M11.941,12.222c-2.2,0-6.578,1.094-6.578,3.289v1.644H18.519V15.511c0-2.2-4.382-3.289-6.578-3.289m0-1.644A3.289,3.289,0,1,0,8.652,7.289,3.289,3.289,0,0,0,11.941,10.578Z" transform="translate(17.737 7.194)" fill="#1a3a4c"/>
                                                </g>
                                                </svg>
                                                Coach User Guide
                                            </button> 
                                            : ""
                                        }
                                        {props.page !== 'participate' ? 
                                        <button className="btn-primary reviewbtn rpsubmitbtn" 
                                        onClick={redirectToRecord}>Participate in a role play</button> 
                                        : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="certificate" className="certify-profile roleplaysap center_line mt-3"></div>
            <Modal show={show} onHide={handleClose} size="md"
                dialogClassName="modalassign addfoldermodal"
                aria-labelledby="example-custom-modal-styling-title"
                centered>
                
                <Modal.Body>
                    <>
                    <div className="tile">
                        Role play User Guide
                    </div>
                        <div className="text-view-page">
                            The <strong>Role play</strong> User Guide helps you understand the features of the Role play section, 
                            so you learn how to participate in a role play. Select <strong>Next</strong> to review the User Guide and <strong>Skip</strong> to leave the page.
                        </div>
                        <div className="btn-sec-footer">
                                <div class="usr-guide-btn d-flex justify-content-center gap-3">
                                <button class="skip-primary" onClick={handleClose}>Skip</button>
                                <button class="btn-primary" onClick={() => {
                                    redirectToGuide('participant')
                                    handleClose();
                                }}>Next</button>
                            </div>
                        </div>
                    </>
                </Modal.Body>
                
            </Modal>
            <Modal show={coachShow} onHide={handleCoachClose} size="md"
                dialogClassName="modalassign addfoldermodal"
                aria-labelledby="example-custom-modal-styling-title"
                centered>
                
                <Modal.Body>
                    <>
                    <div className="tile">
                        Role play User Guide – Coach
                    </div>
                        <div className="text-view-page">
                            The <strong>Role play</strong> – Coach User Guide helps you understand the features of the Role play section, 
                            so that you know how to provide coaching and feedback to the participants. 
                            Select <strong>Next</strong> to review the User Guide and <strong>Skip</strong> to leave the page.​
                        </div>
                        <div className="btn-sec-footer">
                                <div class="usr-guide-btn d-flex justify-content-center gap-3">
                                <button class="skip-primary" onClick={handleCoachClose}>Skip</button>
                                <button class="btn-primary" onClick={() => {
                                    redirectToGuide('coach')
                                    handleCoachClose();
                                }}>Next</button>
                            </div>
                        </div>
                    </>
                </Modal.Body>
                
            </Modal>
        </>
    )   
}

export default RolePlayHeadingSection;